import { z } from "zod";
import formatStringNumberToNumber from "../components/utils/formatStringNumberToNumber";

const formEditNacrtovanaVrednostSchema = z
  .object({
    nacrtovanaVrednost: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    nacrtovaniProjektniViri: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
  })
  .superRefine(({ nacrtovanaVrednost, nacrtovaniProjektniViri }, ctx) => {
    if (nacrtovaniProjektniViri > nacrtovanaVrednost) {
      ctx.addIssue({
        message:
          "Sofinanciranje iz projektnega vira ne sme presegati vrednosti projekta",
        path: ["nacrtovanaVrednost"],
      });
    }
  });

export default formEditNacrtovanaVrednostSchema;
